<template>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
                      style="min-height: 300px"
                      pulling-text="下拉重新获取数据"
                      loosing-text="释放即可重新加载"
                      loading-text=""
                      success-text="数据获取成功">
        <div>

            <van-sticky v-if="searchBox" :z-index="2001">
                <div style="background-color: white;">
                    <div :style="{
                        width: '100%',
                        height: 'env(safe-area-inset-top)'
                      }"
                    ></div>
                    <div style="display: inline-flex">
                        <span style="height: 52px;width: 40px; padding-left: 6px; " @click="clickToHome">
                            <div style=" padding-top: 10px; padding-left: 9px">
                                <van-icon class="changelink_icon" name="wap-home-o" size="18"
                                          color="#EE0A24"></van-icon>
                            </div>
                            <div style="text-align: center; margin-top: -8px; padding-left: 2px; color: #EE0A24">首页</div>
                        </span>

                        <div :style="{width: ($common.screenWidth - 40) + 'px'}">
                            <Wp_search_model :search-value="search_value"
                                             font-color=""
                                             :common-transparent="$common.transparent"
                                             @clickToSearch="clickToSearch"
                                             @getSearchValue="getSearchValue"
                            ></Wp_search_model>
                        </div>

                    </div>

                </div>
            </van-sticky>
            <div>
                <Wp_jd_select_base ref="Wp_jd_select_base"
                                   :url="url"
                                   :filter-box="filterBox"
                                   :offset-top="52"
                                   :keywords="keywords_jd"
                                   @onLoad="onLoad"
                ></Wp_jd_select_base>
            </div>
        </div>
    </van-pull-refresh>
</template>

<script>
    import Wp_search_model from "../custom/Wp_search_model";
    import Wp_jd_select_base from "../pages/Wp_jd_select_base";

    export default {
        name: "Wp_jd_skulist_with_url_filter",
        components: {Wp_jd_select_base, Wp_search_model},
        props: {
            list: {type: Array},
            searchBox: {type: Boolean, default: true},
            filterBox: {type: Boolean, default: true},
        },
        data() {
            return {
                search_value: '',
                //下拉刷新结束
                isLoading: false,

                active: 0,

                keywords_jd: '',
                keywords_pdd: '',
                keywords_tb: '',

                url: '',
            }
        },

        created() {
            this.initUrl();
        },
        mounted() {
            //获取url中的参数search
            //以下逻辑不能放到created中使用，在created中使用，会导致Wp_search_model中的watch监听的searchValue无法被监听到，
            // 应该是created完成后this.search_value才第一次完成创建
            let value = this.$common.getUrlKey("search");
            if (value) {
                let url_param_value = decodeURIComponent(value);
                if (url_param_value) {
                    this.search_value = url_param_value;
                }
            }
        },

        methods: {

            initUrl() {
                if (this.list && this.list.length > 0 && this.list[this.active].props.url) {
                    this.url = this.list[this.active].props.url;
                }
            },

            clickToHome() {
                this.$log("clickToHome")
                this.$router.back();
                if (this.$config.project === 'mini') {
                    this.$wx.miniProgram.navigateBack();
                }
            },

            getRef() {
                return this.$refs.Wp_jd_select_base;
            },

            /**
             * 根据条件查询数据
             */
            clickToSearch() {
                this.getRef().clickToSearch();
                this.searchInputClick('0');
            },

            searchInputClick(id) {
                this.getRef().searchInputClick(id);
            },

            getSearchValue(value) {
                this.search_value = value;
                this.getRef().getSearchValue(value);
            },

            // inputListener(value){
            //     this.search_value = value;
            // },

            /**
             * 下拉刷新
             */
            onRefresh() {
                this.getRef().onRefresh();
            },

            onLoad() {
                //关闭下拉刷新
                this.isLoading = false;
            }
        }
    }
</script>

<style scoped>

</style>